//

export const isUnachievable = (detail) => detail?.achievable === false;

export const hasBreakevenColumn = (detail) => detail?.achievable != null;

export const breakevenCountLabel = (detail) => (
  isUnachievable(detail) ? '—' : Number(detail?.breakeven || 0).toLocaleString()
);
